import Modernizr from 'modernizr'
import Vue from 'vue'
import { prop } from 'rambda'

export default {
  store: {
    state: {
      screenSizes: ['xs'],
      screenWidth: 320,
      // url: null,
      // visited: [],
    },
    getters: {
      isPathDynamic: () => ({ $route: route }) => {
        if (!route || !route.params) return null

        return Object.keys(route.params).includes('slug')
      },
      // visited: state => state.visited,
      // url: state => state.url,

      isDesktop: (_, { screenSizes }) => screenSizes.includes('md'),
      screenSizes: prop('screenSizes'),
      screenWidth: prop('screenWidth'),
    },
    actions: {
      async CHECK_SCREEN_SIZE({ commit }) {
        await Vue.nextTick()
        const width = window.innerWidth || window.document.documentElement.clientWidth || 1
        commit('SET_SCREEN_WIDTH', width)
        commit('SET_SCREEN_SIZES', [
          ['xs', 0],
          ['sm', 576],
          ['md', 768],
          ['lg', 992],
          ['xl', 1200],
          ['xxl', 1601],
          ['xxxl', 1921],
        ].filter(([_, minWidth]) => width >= minWidth)
          .map(([size, _]) => size))
      },

      ON({ dispatch }, events) {
        Object.entries(events).forEach(([eventName, event]) => {
          const passiveEvents = ['mousewheel', 'scroll', 'resize']

          const options =
            Modernizr.passiveeventlisteners && passiveEvents.includes(eventName)
              ? { passive: true }
              : false

          window.addEventListener(eventName, event, options)
        })

        return () => dispatch('OFF', events)
      },
      OFF(_, events) {
        Object.entries(events).forEach(([eventName, event]) => {
          window.removeEventListener(eventName, event)
        })
      },

      // PAGEVIEW({ commit }, { to }) {
      //   commit('SET_URL', to.path)
      //   commit('ADD_VISITED', to.path)
      // },
      // GO_BACK({ state }, { $router, fallback = 'Index' }) {
      //   if (state.visited.length > 1 && state.visited[0] !== state.url) {
      //     $router.go(-1)
      //   } else {
      //     $router.push({ name: fallback })
      //   }
      // },
    },
    mutations: {
      // ADD_VISITED(state, path) {
      //   state.visited.push(path)
      // },
      SET_SCREEN_SIZES(state, screenSizes) {
        state.screenSizes = screenSizes
      },
      SET_SCREEN_WIDTH(state, screenWidth) {
        state.screenWidth = screenWidth
      },
      // SET_URL(state, path) {
      //   state.url = path
      // },
    },
  },
}
